import _defineProperty2 from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/Search';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { TextField, Grid } from '@material-ui/core';
import ClipBoardCopy from './ClipBoardCopy';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
}

function stableSort(array, cmp) {
  var stabilizedThis = array.map(function (el, index) {
    return [el, index];
  });
  stabilizedThis.sort(function (a, b) {
    var order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(function (el) {
    return el[0];
  });
}

function getSorting(order, orderBy) {
  return order === 'desc' ? function (a, b) {
    return desc(a, b, orderBy);
  } : function (a, b) {
    return -desc(a, b, orderBy);
  };
}

var EnhancedTableHead =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EnhancedTableHead, _React$Component);

  function EnhancedTableHead() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EnhancedTableHead);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EnhancedTableHead)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "createSortHandler", function (property) {
      return function (event) {
        _this.props.onRequestSort(event, property);
      };
    });

    return _this;
  }

  _createClass(EnhancedTableHead, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onSelectAllClick = _this$props.onSelectAllClick,
          order = _this$props.order,
          orderBy = _this$props.orderBy,
          numSelected = _this$props.numSelected,
          rowCount = _this$props.rowCount,
          headers = _this$props.headers,
          actionColums = _this$props.actionColums;
      return React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableCell, {
        padding: "checkbox"
      }, actionColums === "checkbox" && React.createElement(Checkbox, {
        indeterminate: numSelected > 0 && numSelected < rowCount,
        checked: numSelected === rowCount,
        onChange: onSelectAllClick
      })), headers.map(function (row) {
        return React.createElement(TableCell, {
          key: row.id,
          padding: row.disablePadding ? 'none' : 'default',
          sortDirection: orderBy === row.id ? order : false
        }, React.createElement(Tooltip, {
          title: "\u0631\u062A\u0628",
          placement: "bottom-start",
          enterDelay: 300
        }, React.createElement(TableSortLabel, {
          active: orderBy === row.id,
          direction: order,
          onClick: _this2.createSortHandler(row.id)
        }, row.label)));
      }, this)));
    }
  }]);

  return EnhancedTableHead;
}(React.Component);

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

var toolbarStyles = function toolbarStyles(theme) {
  return {
    root: {
      paddingRight: theme.spacing.unit
    },
    highlight: theme.palette.type === 'light' ? {
      color: theme.palette.secondary.main,
      backgroundColor: lighten(theme.palette.secondary.light, 0.85)
    } : {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.dark
    },
    spacer: {
      flex: '1 1 50%'
    },
    actions: {
      color: theme.palette.text.secondary
    },
    title: {
      flex: '0 0 auto'
    }
  };
};

var EnhancedTableToolbar = function EnhancedTableToolbar(props) {
  var numSelected = props.numSelected,
      classes = props.classes,
      title = props.title,
      filterRows = props.filterRows;
  return React.createElement(Toolbar, {
    className: classNames(classes.root, _defineProperty2({}, classes.highlight, numSelected > 0))
  }, React.createElement("div", {
    className: classes.title
  }, numSelected > 0 ? React.createElement(Typography, {
    color: "textSecondary",
    variant: "subtitle1"
  }, "\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 ", numSelected) : React.createElement(Typography, {
    variant: "h6",
    id: "tableTitle"
  }, title)), React.createElement("div", {
    className: classes.spacer
  }), React.createElement("div", {
    className: classes.actions
  }, numSelected > 0 ? React.createElement(Tooltip, {
    title: "Delete"
  }, React.createElement(IconButton, {
    "aria-label": "Delete",
    disabled: true
  }, React.createElement(DeleteIcon, null))) : React.createElement(Grid, {
    container: true,
    spacing: 8,
    alignItems: "flex-end"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TextField, {
    id: "standard-search",
    label: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0628\u0631\u064A\u062F",
    type: "search",
    className: classes.textField,
    onChange: filterRows,
    margin: "normal"
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(FilterListIcon, {
    color: "primary"
  })))));
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired
};
EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

var styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3
    },
    table: {// minWidth: 1020,
    },
    tableWrapper: {
      overflowX: 'auto'
    }
  };
};

var EnhancedTable =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(EnhancedTable, _React$Component2);

  function EnhancedTable() {
    var _getPrototypeOf3;

    var _this3;

    _classCallCheck(this, EnhancedTable);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(EnhancedTable)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "state", {
      order: 'asc',
      orderBy: _this3.props.orderBy,
      selected: [],
      data: _this3.props.data,
      page: 0,
      rowsPerPage: 5,
      showSnackBar: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "handleRequestSort", function (event, property) {
      var orderBy = property;
      var order = 'desc';

      if (_this3.state.orderBy === property && _this3.state.order === 'desc') {
        order = 'asc';
      }

      _this3.setState({
        order: order,
        orderBy: orderBy
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "handleSelectAllClick", function (event) {
      if (event.target.checked) {
        _this3.setState(function (state) {
          return {
            selected: state.data.map(function (n) {
              return n.id;
            })
          };
        });

        return;
      }

      _this3.setState({
        selected: []
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "handleClick", function (event, id) {
      var selected = _this3.state.selected;
      var selectedIndex = selected.indexOf(id);
      var newSelected = [];

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      }

      _this3.setState({
        selected: newSelected
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "handleChangePage", function (event, page) {
      _this3.setState({
        page: page
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "handleChangeRowsPerPage", function (event) {
      _this3.setState({
        rowsPerPage: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "isSelected", function (id) {
      return _this3.state.selected.indexOf(id) !== -1;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "filterRows", function (event) {
      var data = _this3.props.data;
      var value = event.target.value;
      value = value.trim();
      if (value) data = data.filter(function (row) {
        return row.email === value || row.id === value;
      });

      _this3.setState({
        data: data
      });
    });

    return _this3;
  }

  _createClass(EnhancedTable, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          headers = _this$props2.headers,
          title = _this$props2.title;
      var _this$state = this.state,
          data = _this$state.data,
          order = _this$state.order,
          orderBy = _this$state.orderBy,
          selected = _this$state.selected,
          rowsPerPage = _this$state.rowsPerPage,
          page = _this$state.page;
      var emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
      var actionColums = this.props.actionColums;
      if (!actionColums) actionColums = "checkbox";
      return React.createElement(Paper, {
        className: classes.root
      }, React.createElement(EnhancedTableToolbar, {
        filterRows: this.filterRows,
        numSelected: selected.length,
        title: title
      }), React.createElement("div", {
        className: classes.tableWrapper
      }, React.createElement(Table, {
        className: classes.table,
        "aria-labelledby": "tableTitle"
      }, React.createElement(EnhancedTableHead, {
        actionColums: actionColums,
        headers: headers,
        numSelected: selected.length,
        order: order,
        orderBy: orderBy,
        onSelectAllClick: this.handleSelectAllClick,
        onRequestSort: this.handleRequestSort,
        rowCount: data.length
      }), React.createElement(TableBody, null, stableSort(data, getSorting(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (n) {
        var isSelected = _this4.isSelected(n.id);

        return React.createElement(TableRow, _extends({
          hover: true
        }, actionColums === "checkbox" ? {
          onClick: function onClick(event) {
            return _this4.handleClick(event, n.id);
          }
        } : {}, {
          "aria-checked": isSelected,
          tabIndex: -1,
          key: n.id,
          selected: isSelected
        }), React.createElement(TableCell, {
          padding: "checkbox"
        }, actionColums === "checkbox" ? React.createElement(Checkbox, {
          checked: isSelected
        }) : React.createElement(ClipBoardCopy, {
          text: n.id
        })), headers.map(function (row, idx) {
          return React.createElement(TableCell, {
            component: idx === 0 ? 'th' : 'td',
            key: "row-".concat(row.id, "-").concat(n.id),
            padding: "none" // align={row.numeric ? 'right' : 'left'}

          }, row.type === "date" ? n[row.id] ? new Date(n[row.id]).toLocaleString() : "" : n[row.id]);
        }));
      }), emptyRows > 0 && React.createElement(TableRow, {
        style: {
          height: 49 * emptyRows
        }
      }, React.createElement(TableCell, {
        colSpan: 6
      }))))), React.createElement(TablePagination, {
        labelDisplayedRows: function labelDisplayedRows(_ref) {
          var from = _ref.from,
              to = _ref.to,
              count = _ref.count;
          return "\u0639\u0631\u0636 \u0645\u0646 ".concat(from, " \u0625\u0644\u0649 ").concat(to, " \u0645\u0646 \u0623\u0635\u0644 ").concat(count);
        },
        labelRowsPerPage: "\u0639\u062F\u062F \u0627\u0644\u0623\u0633\u0637\u0631 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629",
        rowsPerPageOptions: [5, 10, 25],
        component: "div",
        count: data.length,
        rowsPerPage: rowsPerPage,
        page: page,
        backIconButtonProps: {
          'aria-label': 'السابق'
        },
        nextIconButtonProps: {
          'aria-label': 'التالي'
        },
        onChangePage: this.handleChangePage,
        onChangeRowsPerPage: this.handleChangeRowsPerPage
      }));
    }
  }]);

  return EnhancedTable;
}(React.Component);

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired
};
export default withStyles(styles)(EnhancedTable);